import { Component, Vue } from 'vue-property-decorator';

import DottedLine from '@/assets/icons/dotted-line.svg?inline';
import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';

import Cutout from '@/components/CutoutComponent/CutoutComponent.vue';

import { ImageWidths, ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import { getComponentProps } from '@/utils/vueUtils';
import { IntroRichBlockViewModel } from './IntroRichModule.types';
import { getResizeImage } from '@/utils/commonUtils';

const IntroRichModuleProps = Vue.extend({
  props: getComponentProps<IntroRichBlockViewModel>({
    Title: 'Alaska the land of thrill beauty and midnight sun',
    TextBody:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean egestas rhoncus diam vitae vestibulum. Donec placerat est sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Quam lacus suspendisse faucibus interdum posuere lorem. Arcu dictum varius duis at consectetur lorem donec massa sapien. Quis commodo odio aenean sed adipiscing diam donec. Nec feugiat nisl pretium fusce id velit. Semper feugiat nibh sed pulvinar proin gravida hendrerit lectus. Cursus sit amet dictum sit amet justo donec enim diam.<a href="#" class="cta cta--inline">consectetur</a>',
    Image: {
      Url: getResizeImage('fish.png'),
      Alt: 'Fish',
      OriginalWidth: 967,
      OriginalHeight: 545,
    },
    AlternateImageLayout: false,
  }),
});

@Component({
  components: {
    DottedLine,
    ResponsiveImageRatio,
    Cutout,
  },
})
export default class IntroRichModule extends IntroRichModuleProps {
  //Sizes have been commented out for now as they were causing a weird issue scaling the fish/parrot cutout
  //Needs to be looked at properly to see if this is needed or can be deleted
  imageWidths: ImageWidths = {
    def: 463,
    sizes: {
      // sm: 636,
      // md: 992,
      // lg: 793,
      // xl: 993,
    },
  };

  alternateImageWidths: ImageWidths = {
    def: 463,
    sizes: {
      sm: 636,
      md: 992,
      lg: 793,
      xl: 993,
    },
  };

  get ImageWidths() {
    return this.p.AlternateImageLayout ? this.alternateImageWidths : this.imageWidths;
  }

  cutoutSizes: ImageSizes[] = [
    {
      def: new ImageSize([100, 100]),
      sizes: {
        md: new ImageSize([175, 175]),
        xl: new ImageSize([182, 182]),
      },
    },
    {
      def: new ImageSize([54, 54]),
      sizes: {
        md: new ImageSize([97, 97]),
      },
    },
  ];
}
